/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { ProtectedGcpWorkloadsContext } from '../contexts/ProtectedGcpWorkloadsContext';

export const useProtectedGcpWorkloadsStore = () => useContext(ProtectedGcpWorkloadsContext);
